"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = exports.EnhancementsDescriptor = exports.EnhancementTuple = exports.MixRatioScalar = exports.WaterDescriptor = exports.WaterType = exports.Otp = void 0;
const effect_1 = require("effect");
const Unit = __importStar(require("../../../../unit"));
const number_1 = require("../../../../utils/number");
const Water = __importStar(require("../../../water"));
const MixRatio = __importStar(require("../../capability/consumable/definition/enhancement/mix-ratio"));
const liquid_enhancement_1 = require("../../capability/consumable/definition/liquid-enhancement");
const NAMESPACE = 'Culligan.Device.Class.Pelican2.Remote';
exports.Otp = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${NAMESPACE}.Otp`,
    description: 'A one-time password that authenticates a remote session.',
});
exports.WaterType = effect_1.Schema.Enums(effect_1.Struct.pick(Water.Type.enums, 'AmbientStill', 'Chilled', 'Sparkling', 'Hot')).annotations({
    identifier: `${NAMESPACE}.WaterType`,
    description: 'A water type that is supported by Twist.',
});
const MilliliterFromPositiveInt = number_1.PositiveInt.pipe(Unit.Into(Unit.Volume.Milliliter)).annotations({
    identifier: `${NAMESPACE}.MilliliterFromPositiveInt`,
});
exports.WaterDescriptor = effect_1.Schema.Struct({
    type: effect_1.Schema.propertySignature(exports.WaterType).annotations({
        title: 'Type',
        description: 'The type of water to be dispensed.',
    }),
    volume: effect_1.Schema.optionalWith(MilliliterFromPositiveInt, {
        exact: true,
        as: 'Option',
    }).annotations({
        title: 'Volume',
        description: 'The volume of water to be dispensed, expressed in milliliters. ' +
            'If unspecified, the dispense must be stopped manually using a `dispense.stop` command.',
    }),
}).annotations({
    identifier: `${NAMESPACE}.WaterDescriptor`,
});
exports.MixRatioScalar = MixRatio.MixRatioScalar.annotations({
    identifier: `${NAMESPACE}.MixRatioScalar`,
    description: 'If the device is unable to comply with the specified mix ratio scalar, ' +
        'the device should reject the command',
});
exports.EnhancementTuple = effect_1.Schema.Tuple(liquid_enhancement_1.LiquidEnhancement.CatalogueItemFromId, exports.MixRatioScalar).annotations({
    identifier: `${NAMESPACE}.EnhancementTuple`,
    description: 'A tuple describing a `LiquidEnhancement` catalogue item and its selected mix ratio scalar.',
});
exports.EnhancementsDescriptor = effect_1.Schema.NonEmptyArray(exports.EnhancementTuple)
    .pipe(effect_1.Schema.filter(tuples => {
    const ids = tuples.map(([{ id }]) => id);
    const duplicateIds = effect_1.Array.dedupe(ids.filter((id, index) => ids.indexOf(id) !== index));
    return (duplicateIds.length === 0 ||
        `May not contain duplicate IDs: ${duplicateIds.map(id => `"${id}"`).join(', ')}`);
}))
    .annotations({
    identifier: `${NAMESPACE}.EnhancementsDescriptor`,
});
exports.Order = effect_1.Schema.Struct({
    water: effect_1.Schema.propertySignature(exports.WaterDescriptor).annotations({
        title: 'Water',
    }),
    enhancements: effect_1.Schema.optionalWith(exports.EnhancementsDescriptor, {
        exact: true,
        as: 'Option',
    }).annotations({
        title: 'Enhancements',
        description: 'List of enhancements and their mix ratio scalars to be mixed into the drink.',
    }),
}).annotations({
    identifier: `${NAMESPACE}.Order`,
    description: 'Struct describing the selections made on the remote.',
});
//# sourceMappingURL=remote.js.map